var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElectricVehicleCharging(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 176,
    height: 176,
    viewBox: "0 0 176 176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Electric_Vehicle_Charging",
    "data-name": "Electric Vehicle Charging",
    transform: "translate(0.041)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 88,
    cy: 88,
    r: 88,
    transform: "translate(-0.041)",
    fill: "rgba(214,233,255,0.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 75.3,
    cy: 75.3,
    r: 75.3,
    transform: "translate(12.7 12.7)",
    fill: "#d1e6ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10631",
    "data-name": "Group 10631",
    transform: "translate(27 27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10630",
    "data-name": "Group 10630"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 61,
    cy: 61,
    r: 61,
    transform: "translate(-0.041)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "electric_car_black_24dp",
    transform: "translate(52.792 53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11382",
    "data-name": "Group 11382",
    transform: "translate(0.188)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2264",
    "data-name": "Rectangle 2264",
    width: 70,
    height: 70,
    transform: "translate(-0.022)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11384",
    "data-name": "Group 11384",
    transform: "translate(5.999 0.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11383",
    "data-name": "Group 11383"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3618",
    "data-name": "Path 3618",
    d: "M5,23.893H49.5V8H5ZM41.554,11.179a4.768,4.768,0,1,1-4.768,4.768A4.762,4.762,0,0,1,41.554,11.179Zm-28.608,0a4.768,4.768,0,1,1-4.768,4.768A4.762,4.762,0,0,1,12.947,11.179Z",
    transform: "translate(1.357 14.251)",
    fill: "#d6e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3619",
    "data-name": "Path 3619",
    d: "M53.6,4.21A4.749,4.749,0,0,0,49.09,1H14.125A4.78,4.78,0,0,0,9.612,4.21L3,23.251V48.68a3.188,3.188,0,0,0,3.179,3.179H9.357a3.188,3.188,0,0,0,3.179-3.179V45.5H50.68V48.68a3.188,3.188,0,0,0,3.179,3.179h3.179a3.188,3.188,0,0,0,3.179-3.179V23.251ZM15.238,7.357H47.946l3.433,9.886H11.8ZM53.858,39.144H9.357V23.251h44.5Z",
    transform: "translate(-3 -1)",
    fill: "#12355f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2664",
    "data-name": "Ellipse 2664",
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    transform: "translate(9.168 24.312)",
    fill: "#12355f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2665",
    "data-name": "Ellipse 2665",
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    transform: "translate(37.168 24.312)",
    fill: "#12355f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3620",
    "data-name": "Path 3620",
    d: "M7,24.357H19.715V18l19.072,9.536H26.072v6.357Z",
    transform: "translate(5.715 36.037)",
    fill: "#12355f"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricVehicleCharging);
export default __webpack_public_path__ + "static/media/Electric Vehicle Charging.f4c465a667330ac6ddde7d31d1f65fa6.svg";
export { ForwardRef as ReactComponent };